// extracted by mini-css-extract-plugin
export var columnItem = "_ap-3";
export var columnItemDraggable = "_ap-4";
export var dragHandle = "_ap-0";
export var dragHandleHovered = "_ap-1";
export var dropdown = "_ap-5";
export var dropdownContent = "_ap-7";
export var dropdownInner = "_ap-6";
export var filterDropdownHeader = "_ap-8";
export var icon = "_ap-2";
export var sectionDivider = "_ap-9";